const s = {
  'next': 'Successivo',
  'prev': 'Precedente',
  'select...': 'Seleziona...',
  'brand': 'Brand',
  'select a date': 'Seleziona una data',
  'select hour': 'Seleziona un orario',
  'day': 'Giorno',
  'time': 'Ora',
  'location': 'Location',
  'your data': 'I tuoi dati',
  'date and time': 'Data e orario',
  'num people': 'Quante persone',
  'err num people': 'Seleziona il numero di persone',
  'workshop list': 'Prenota ora la tua sessione',
  'signup': 'Registrati',

  'first name': 'Nome',
  'last name': 'Cognome',
  'name': 'Nome',
  'appointment day': 'Giorno appuntamento',
  'email': 'Email',
  'phone': 'Telefono',
  'phone_scemi': 'Telefono',
  'phone_scemi_placeholder': '333 12345678',
  'prefix_scemi_placeholder': 'Es. +39',
  'whatsapp': 'WhatsApp',
  'appointment type': 'Tipo appuntamento',
  'preferred contact': 'Contatto preferito',
  'preferred language': 'Lingua preferita',
  'product category': 'Categoria prodotti',
  'notes': 'Note',
  'subscribe to newsletter': 'Iscriviti alla newsletter',
  'slot unavailable': 'L\'orario scelto non è più disponibile',
  'choose another time slot': 'Scegli un altro orario',
  'confirm': 'Conferma',
  'sending': 'Sto inviando',
  'appointment confirmed': 'Grazie per aver prenotato!<br>Riceverai a breve una mail di conferma.',

  'onsite': 'In negozio',
  'online': 'Online',

  'italian': 'Italiano',
  'english': 'Inglese',
  'french': 'Francese',
  'chinese': 'Cinese',
  'russian': 'Russo',
  'japanese': 'Giapponese',
  'korean': 'Koreano',

  'Abbigliamento Bambino': 'Abbigliamento Bambino',
  'Abbigliamento Donna': 'Abbigliamento Donna',
  'Abbigliamento Uomo': 'Abbigliamento Uomo',
  'Accessori': 'Accessori',
  'Arredamento': 'Arredamento',
  'Borse': 'Borse',
  'Calzature': 'Calzature',
  'Calzature Donna': 'Calzature Donna',
  'Calzature Uomo': 'Calzature Uomo',
  'Fragranze': 'Fragranze',
  'Gioielleria': 'Gioielleria',
  'Occhiali Da Sole': 'Occhiali Da Sole',
  'Orologi': 'Orologi',
  'Pelletteria': 'Pelletteria',
  'Pellicceria': 'Pellicceria',

  'fill all fields': 'Compila tutti i campi contrassegnati con l\'asterisco (*) per continuare',
}

export default s;